import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { getWindow } from "../../../utils/browser-features";
import { bodyClassesState } from "../../meta/state/atoms";
import { reducedMotionState } from "../state/atoms";

export const useGetReducedMotion = () => useRecoilValue(reducedMotionState);

export function useListenCookieCompletion() {
  const setBodyClasses = useSetRecoilState(bodyClassesState);
  const setReducedMotionState = useSetRecoilState(reducedMotionState);

  useEffect(() => {
    const isAxeptioInBotMode = () => window.axeptioSDK?.on === undefined;

    function stopAnimations() {
      setBodyClasses((oldBodyClasses) => [...oldBodyClasses, "halt-animations"]);
      setReducedMotionState("always");
    }

    function startAnimations() {
      setBodyClasses((oldBodyClasses) =>
        oldBodyClasses.filter((className) => className !== "halt-animations")
      );
      setReducedMotionState("user");
    }

    const initAnimationsListener = () => {
      stopAnimations();
      if (isAxeptioInBotMode()) {
        startAnimations();
      } else {
        window.axeptioSDK.on("cookies:complete", () => {
          startAnimations();
        });
      }
    };

    if (getWindow()?.axeptioSDK) {
      initAnimationsListener();
    } else {
      document.addEventListener("axeptio_loaded", initAnimationsListener);
    }
  }, [setBodyClasses, setReducedMotionState]);
}
